import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { PassengersDataList } from 'features/passengers/components/PassengersDataList';
import { CLIENT_LIST_FIXED_FILTERS } from 'features/passengers/components/PassengersDataList/constants';

export const CustomersList = (): JSX.Element => {
	return (
		<Layout>
			<Container component="main" maxWidth="xl" sx={{ py: 4 }}>
				<Box sx={{ mb: 3 }}>
					<Typography variant="h5" sx={{ fontWeight: 600 }}>
						Clientes
					</Typography>
					<Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
						Contactos facturables del sistema
					</Typography>
				</Box>
				<PassengersDataList variant="client" fixedFilters={CLIENT_LIST_FIXED_FILTERS} showPersonTypeTabs />
			</Container>
		</Layout>
	);
};
